import React from "react"
import PropTypes from "prop-types"

// components
import Slider, { Range } from "rc-slider"

const SliderRange = Slider.createSliderWithTooltip(Range)

// This component renders the slider to filter numerical columns
const ColumnSearchSliderRange = ({ value, search, columnRange, isPercentColumn = false }) => (
    <div>
        <SliderRange
            onAfterChange={search}
            defaultValue={
                value
                    ? isPercentColumn
                        ? value * 100
                        : value
                    : isPercentColumn
                    ? columnRange.map((x) => x * 100)
                    : columnRange
            }
            min={isPercentColumn ? columnRange[0] * 100 : columnRange[0]}
            max={isPercentColumn ? columnRange[1] * 100 : columnRange[1]}
            step={0.01}
        />
    </div>
)

ColumnSearchSliderRange.propTypes = {
    columnRange: PropTypes.array,
    search: PropTypes.func.isRequired,
}

ColumnSearchSliderRange.defaultProps = {
    columnRange: [0, 100],
}

export default ColumnSearchSliderRange
